export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  image: string;
  category: string;
  tags: string[];
  readTime: number;
  featured?: boolean;
  relatedServiceId?: string;
  relatedPageLink?: string;
}

// --- ARTIGOS CANALIZAÇÕES (LISBOA) ---
const articlesCanalizacoes: Omit<Article, 'author'>[] = [
  {
    id: '1',
    title: 'Como Descobrir uma Fuga de Água Sem Partir Paredes (Lisboa)',
    slug: 'como-descobrir-fuga-agua-sem-partir-paredes-lisboa',
    excerpt: 'Aprenda a identificar fugas de água ocultas e como a tecnologia moderna permite localizá-las sem destruir nada.',
    content: `
      <h2>Como saber se há uma fuga em casa?</h2>
      <p>A maioria das fugas de água não é visível. Elas acontecem dentro das paredes ou debaixo do piso e só são percebidas quando já causaram manchas, bolhas ou aumento inesperado na conta de água.</p>
      <p>Em Lisboa, onde muitas casas têm canalizações antigas, este é um problema comum — e que pode custar caro se não for tratado rapidamente.</p>
      <h2>Sinais de fuga oculta:</h2>
      <ul>
        <li><strong>Conta de água mais alta que o normal:</strong> Se a sua conta de água aumentou sem motivo aparente, pode ser sinal de fuga.</li>
        <li><strong>Piso quente, húmido ou com manchas:</strong> Pisos quentes podem indicar fugas em tubos de água quente.</li>
        <li><strong>Paredes com mofo ou tinta a descascar:</strong> Manchas nas paredes indicam possíveis fugas.</li>
      </ul>
      <h2>Tecnologia moderna para localizar fugas</h2>
      <p>Empresas especializadas como a <strong>Alpha Canalizações</strong> usam tecnologia avançada: câmeras térmicas, sensores acústicos e gás traçador — tudo sem destruir nada.</p>
      <h2>Conclusão</h2>
      <p>Suspeita que há uma fuga em casa? Não espere o estrago aumentar. Entre em contacto com especialistas em Lisboa.</p>
    `,
    date: '2025-01-20',
    image: '/images/manutencao-preventiva-real.webp',
    category: 'Dicas',
    tags: ['fugas', 'deteção', 'tecnologia', 'lisboa'],
    readTime: 6,
    featured: true,
    relatedServiceId: 'fugas'
  },
  {
    id: 'cl1',
    title: 'Inspeção de Canalizações em Prédios Históricos de Lisboa',
    slug: 'inspeção-canalizacoes-predios-historicos-lisboa',
    excerpt: 'Por que os prédios antigos em zonas como Alfama e Baixa Pombalina requerem atenção especial na canalização.',
    content: `
      <h2>O Desafio dos Prédios Antigos</h2>
      <p>Lisboa é famosa pelo seu charme histórico, mas por trás das fachadas bonitas, as canalizações em chumbo ou ferro galvanizado podem estar a chegar ao fim da sua vida útil.</p>
      <h2>Riscos de Tubagens Antigas:</h2>
      <ul>
        <li><strong>Contaminação por Chumbo:</strong> Material proibido nos dias de hoje mas comum em prédios antes de 1970.</li>
        <li><strong>Corrosão Interna:</strong> Diminui a pressão da água e causa fugas lentas.</li>
        <li><strong>Infiltrações Estruturais:</strong> Podem comprometer a segurança do edifício.</li>
      </ul>
      <p>A <strong>Alpha Canalizações</strong> é especialista em renovação de sistemas em centros históricos, utilizando materiais modernos como PPR e Multicamada.</p>
    `,
    date: '2025-02-10',
    image: '/images/manutencao-preventiva-real.webp',
    category: 'Manutenção',
    tags: ['lisboa', 'histórico', 'reabilitação', 'canalização'],
    readTime: 7,
    featured: true
  }
];

// --- ARTIGOS DESENTUPIMENTOS ---
const articlesDesentupimentos: Omit<Article, 'author'>[] = [
  {
    id: '7',
    title: 'Sinais de que Precisa de Desentupimento Urgente',
    slug: 'sinais-desentupimento-urgente',
    excerpt: 'Identifique quando precisa de um desentupimento urgente e como agir.',
    content: `
      <h2>Sinais de Alerta</h2>
      <p>Alguns sinais indicam que precisa de um desentupimento urgente: água a transbordar, mau cheiro e retorno de resíduos pelos ralos.</p>
      <p>A <strong>Alpha Desentupimentos</strong> oferece atendimento 24h para resolver estas emergências rapidamente.</p>
    `,
    date: '2024-12-28',
    image: '/images/manutencao-preventiva-real.webp',
    category: 'Urgência',
    tags: ['desentupimentos', 'urgente', '24h'],
    readTime: 4,
    featured: true,
    relatedServiceId: 'desentupimentos'
  },
  {
    id: 'd1',
    title: 'Hidrojato vs Sonda Elétrica: Qual a Melhor Solução?',
    slug: 'hidrojato-vs-sonda-eletrica-desentupimentos',
    excerpt: 'Descubra a diferença entre estas duas tecnologias e quando cada uma deve ser aplicada nos seus esgotos.',
    content: `
      <h2>Hidrojato: A Força da Água</h2>
      <p>Ideal para colunas de prédios e gordura acumulada em cozinhas. O hidrojato limpa as paredes internas do cano como se fossem novas.</p>
      <h2>Sonda Elétrica: Precisão e Alcance</h2>
      <p>Excelente para remover objetos sólidos, raízes de árvores ou entupimentos específicos em sanitas e pias.</p>
      <p>Na <strong>Alpha Desentupimentos</strong>, avaliamos cada caso para usar a ferramenta que garante a solução definitiva sem danificar a sua canalização.</p>
    `,
    date: '2025-02-12',
    image: '/images/manutencao-preventiva-real.webp',
    category: 'Técnico',
    tags: ['hidrojato', 'sonda elétrica', 'tecnologia'],
    readTime: 5,
    featured: true
  }
];

// --- ARTIGOS PORTO ---
const articlesPorto: Omit<Article, 'author'>[] = [
  {
    id: 'p1',
    title: 'Problemas de Canalização Comuns nas Zonas Históricas do Porto',
    slug: 'problemas-canalizacao-zonas-historicas-porto',
    excerpt: 'Vila Nova de Gaia e a Ribeira do Porto têm desafios específicos devido à humidade e idade das infraestruturas.',
    content: `
      <h2>Humidade e Salinidade</h2>
      <p>A proximidade ao Rio Douro e ao Oceano traz desafios extras para as peças metálicas da sua canalização.</p>
      <p>No Porto, a manutenção preventiva é crucial para evitar a oxidação prematura de válvulas e torneiras.</p>
      <p>A <strong>Alpha Canalizações Porto</strong> conhece bem a realidade da região e oferece soluções duradouras.</p>
    `,
    date: '2025-02-11',
    image: '/images/manutencao-preventiva-real.webp',
    category: 'Regional',
    tags: ['porto', 'ribeira', 'gaia', 'canalização'],
    readTime: 6,
    featured: true
  },
  {
    id: 'p2',
    title: 'Inundações no Porto: O Que Fazer Enquanto o Canalizador Não Chega',
    slug: 'inundacoes-porto-guia-emergencia',
    excerpt: 'Guia de emergência para conter danos causados por ruturas de canos em casas e estabelecimentos comerciais no Porto.',
    content: `
      <h2>1. Localize o Ponto de Corte Geral</h2>
      <p>Todo o habitante do Porto deve saber onde fica a torneira de segurança. Fechar a água é o primeiro passo para parar o prejuízo.</p>
      <h2>2. Afaste Equipamentos Elétricos</h2>
      <p>A segurança elétrica é prioridade. Água e eletricidade não se misturam.</p>
      <p>A <strong>Alpha Canalizações Porto</strong> garante atendimento expresso em toda a Invicta.</p>
    `,
    date: '2025-02-05',
    image: '/images/manutencao-preventiva-real.webp',
    category: 'Urgência',
    tags: ['emergência', 'porto', 'inundação'],
    readTime: 5,
    featured: false
  }
];

// --- ARTIGOS ELÉTRICA ---
const articlesEletrica: Omit<Article, 'author'>[] = [
  {
    id: 'e1',
    title: '5 Motivos para Trocar a Iluminação da Sua Casa por LED',
    slug: 'motivos-trocar-iluminacao-led',
    excerpt: 'Descubra como a iluminação LED pode reduzir a sua conta de luz em até 80%.',
    content: `
      <h2>1. Economia Imbatível</h2>
      <p>O LED é muito mais eficiente que as lâmpadas tradicionais, reduzindo drasticamente a conta de energia.</p>
      <p>A <strong>Alpha Elétrica</strong> ajuda na transição completa da sua iluminação para sistemas inteligentes e eficientes.</p>
    `,
    date: '2025-01-15',
    image: '/images/instalacao-eletrica-real.webp',
    category: 'Economia',
    tags: ['led', 'iluminação', 'economia'],
    readTime: 4,
    featured: true,
    relatedServiceId: 'iluminacao'
  },
  {
    id: 'e5',
    title: 'Guia de Instalação de Carregadores para Carros Elétricos (Wallbox)',
    slug: 'instalacao-carregador-carro-eletrico-wallbox',
    excerpt: 'Quer carregar o seu veículo elétrico em casa com segurança? Saiba o que é necessário para instalar uma Wallbox.',
    content: `
      <h2>Potência e Segurança</h2>
      <p>Não basta ligar o carro a uma tomada comum. Para um carregamento rápido e seguro, é necessária uma instalação dedicada com proteções específicas.</p>
      <p>A <strong>Alpha Elétrica</strong> é certificada para instalação de carregadores domésticos e em condomínios.</p>
    `,
    date: '2025-02-08',
    image: '/images/instalacao-eletrica-real.webp',
    category: 'Tecnologia',
    tags: ['veículos elétricos', 'wallbox', 'mobilidade'],
    readTime: 6,
    featured: true
  },
  {
    id: 'e6',
    title: 'Smart Home: O Primeiro Passo para Automatizar a Sua Casa',
    slug: 'smart-home-automacao-eletrica-iniciantes',
    excerpt: 'Conselhos profissionais para começar a automatizar a iluminação e tomadas da sua casa sem gastar uma fortuna.',
    content: `
      <h2>Por Onde Começar?</h2>
      <p>Interruptores inteligentes e sensores de movimento são os melhores pontos de partida. Além de conforto, geram poupança real ao evitar luzes acesas desnecessariamente.</p>
      <p>A <strong>Alpha Elétrica</strong> projeta e instala sistemas de domótica simples e eficazes.</p>
    `,
    date: '2025-02-13',
    image: '/images/instalacao-eletrica-real.webp',
    category: 'Modernização',
    tags: ['domótica', 'smart home', 'tecnologia'],
    readTime: 5,
    featured: false
  }
];

import { siteConfig } from '../config/site';

// Determinar qual lista de artigos usar baseado no domínio ou siteConfig.name
const getArticlesBySite = () => {
  if (siteConfig.domain === 'alphaeletrica.pt' || siteConfig.domain === 'alphaeletric.pt') return articlesEletrica;
  if (siteConfig.domain === 'alphadesentupimentos.pt') return articlesDesentupimentos;
  if (siteConfig.domain === 'alphacanalizacoesporto.pt') return articlesPorto;
  return articlesCanalizacoes; // Padrão
};

export const articles: Article[] = getArticlesBySite().map(article => ({
  ...article,
  author: siteConfig.name
} as Article));


